const translation = {
  title: 'Retrieval Testing',
  desc: 'Test the hitting effect of the Knowledge based on the given query text.',
  dateTimeFormat: 'MM/DD/YYYY hh:mm A',
  recents: 'Recents',
  table: {
    header: {
      source: 'Source',
      text: 'Text',
      time: 'Time',
    },
  },
  input: {
    title: 'Source text',
    placeholder: 'Please enter a text, a short declarative sentence is recommended.',
    countWarning: 'Up to 200 characters.',
    indexWarning: 'High quality Knowledge only.',
    testing: 'Testing',
  },
  hit: {
    title: 'RETRIEVAL PARAGRAPHS',
    emptyTip: 'Retrieval Testing results will show here',
  },
  noRecentTip: 'No recent query results here',
  viewChart: 'View VECTOR CHART',
}

export default translation
